export const LANGUAGE_CHOICE_KEY = 'languageChoice';

export type MarketLanguageCode = 'fr' | 'en' | 'es' | 'de' | 'it' | 'nl-BE' | 'nl-NL';

const SUPPORTED_BASE: Record<string, MarketLanguageCode> = {
  fr: 'fr',
  en: 'en',
  es: 'es',
  de: 'de',
  it: 'it',
};

function base(tag: string): string {
  return tag.trim().replace('_', '-').toLowerCase().split('-')[0] || '';
}

export function pickLanguageForMarket(
  country: string | null | undefined,
  navigatorLanguages: readonly string[]
): MarketLanguageCode | null {
  const code = (country || '').trim().toLowerCase();
  if (code !== 'be' && code !== 'nl') return null;
  const tags = navigatorLanguages.map((tag) => tag.trim()).filter(Boolean);
  if (code === 'nl') {
    for (const tag of tags) {
      const normalized = tag.replace('_', '-').toLowerCase();
      if (normalized === 'nl-be') return 'nl-BE';
      if (normalized.startsWith('nl')) return 'nl-NL';
      const mapped = SUPPORTED_BASE[base(tag)];
      if (mapped) return mapped;
    }
    return 'nl-NL';
  }
  for (const tag of tags) {
    const normalized = tag.replace('_', '-').toLowerCase();
    if (normalized.startsWith('nl')) return 'nl-BE';
    if (normalized.startsWith('de')) return 'de';
    const mapped = SUPPORTED_BASE[base(tag)];
    if (mapped) return mapped;
  }
  return 'fr';
}

export function readLanguageChoice(): 'explicit' | 'auto' | null {
  try {
    const raw = localStorage.getItem(LANGUAGE_CHOICE_KEY);
    if (raw === 'explicit' || raw === 'auto') return raw;
    return null;
  } catch {
    return null;
  }
}

export function markLanguageChoice(choice: 'explicit' | 'auto'): void {
  try {
    localStorage.setItem(LANGUAGE_CHOICE_KEY, choice);
  } catch {
    /* ignore */
  }
}
